import { Typography } from 'components/Typography'

export const NoUsersState = () => (
  <Typography.Body1 className="mt-12 text-center">
    No users found
  </Typography.Body1>
)
